// Язык для сайта

export const LANG = {
  EN: "en",
  GE: "ge",
} as const;

export type TLang = (typeof LANG)[keyof typeof LANG];

export const LANGS = Object.values(LANG);

export const languagesFullname = {
  [LANG.EN]: "English",
  [LANG.GE]: "German",
} as const;

export type TLangFullnameVal =
  (typeof languagesFullname)[keyof typeof languagesFullname];

// Язык для моделей

export type TLangModelId = number;
export interface ILangModel {
  id: TLangModelId;
  language: string;
  createdAt: string;
  updatedAt: string;
}
export interface ILangModelCreated {
  language: string;
}
export interface ILangModelDeleted {
  languageId: number;
}
